// @mui material components
import { Tooltip } from "@mui/material";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

// Ajce Hostel App React example components
import TimelineItem from "examples/Timeline/TimelineItem";
import { useEffect } from "react";
import { toDMY } from "utils/date";

function BehaviourTimeline({ timelineData, fetchBehaviourTimeline, setAddTimelineModalOpen }) {
  const [MUIController] = useMaterialUIController();
  useEffect(() => {
    fetchBehaviourTimeline();
  }, []);
  return (
    <Card sx={{ height: "100%", width: "100%", padding: "10px" }}>
      <MDBox
        py={2}
        px={3}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <MDTypography variant="h5" fontWeight="medium" mb={1}>
          Behaviour Timeline
        </MDTypography>
        <MDButton
          color={MUIController.sidenavColor}
          variant="gradient"
          onClick={() => setAddTimelineModalOpen(true)}
        >
          Add Timeline Entry
        </MDButton>
      </MDBox>
      <MDBox p={2}>
        {timelineData?.length !== 0 ? (
          timelineData.map((data) => (
            <TimelineItem
              key={data.id}
              color={data.type === "pos" ? "success" : data.type === "neg" ? "error" : "grey"}
              icon={
                data.type === "pos"
                  ? "sentiment_satisfied"
                  : data.type === "neg"
                  ? "sentiment_dissatisfied"
                  : "sentiment_neutral"
              }
              title={data.note}
              dateTime={toDMY(data.date.toDate())}
            />
          ))
        ) : (
          <MDTypography variant="body" align="center" px={3} sx={{ fontSize: "0.9rem" }}>
            No timeline entries.
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}

export default BehaviourTimeline;
